import { Button, Flex, LightMode, Text } from "@chakra-ui/react";
import { useTranslate } from "@tolgee/react";
import { NavLink } from "react-router-dom";

function LoginErrorPage() {
  const { t } = useTranslate();
  return (
    <LightMode>
      <Flex
        justifyContent={"center"}
        alignItems={"center"}
        height="100vh"
        bg="white"
        color="gray.800"
      >
        <Flex direction={"column"} padding={8}>
          <div>
            <img
              src="/images/ctm-logo-landscape.png"
              title="Corporate Travel Management"
              alt="CTM Logo"
              aria-hidden
            />
          </div>
          <Text mt="48px" fontSize="5xl" mb={1}>
            {t({
              key: "pages.loginErrorPage.signInFailed",
              defaultValue: "Sign in failed.",
            })}
          </Text>
          <Text fontSize="5xl" mb={6}>
            {t({
              key: "pages.loginErrorPage.pleaseTryAgain",
              defaultValue: "Please Try Again.",
            })}
          </Text>
          <div>
            <Button
              colorScheme="blue"
              variant={"solid"}
              as={NavLink}
              to="/logout"
              _hover={{ bg: "blue.400", color: "white" }}
            >
              {t({
                key: "pages.loginErrorPage.retryButtonText",
                defaultValue: "Try Again",
              })}
            </Button>
          </div>
          <Text mt={8} color="gray.500" fontSize={"sm"}>
            *
            {t({
              key: "pages.loginErrorPage.helpMessage",
              defaultValue:
                "If you continue to have log in issues, please contact your consultant.",
            })}
          </Text>
        </Flex>
      </Flex>
    </LightMode>
  );
}

export default LoginErrorPage;
